import { SseStatus } from "hooks/useRequest";

// AIリサーチのモード定義
export type AiResearchType =
  | "newChat" // 新規チャット
  | "history"; // 履歴

// 履歴の型
// TODO: API 接続後に更新
export interface History {
  talkId: string;
  title: string;
  date: string;
}

// ソースの型
// TODO: API 接続後に更新
export interface Source {
  id: number;
  media: string;
}

export interface ReferenceDetail {
  body?: string | null;
  keyPdf?: string | null;
  sourceLink?: string | null;
  sourcePdf?: string | null;
}

export interface ArticleReference extends ReferenceDetail {
  citationNumber: number;
  dataType: "article_chunk";
  data: {
    articleId: string;
    charLength: number;
    chunkId: string;
    mediaCode: string;
    mediaName: string;
    publishDate: number;
    source: string;
    title: string;
  };
}

export interface FinancialChartReference extends ReferenceDetail {
  citationNumber: number;
  dataType: "financial_chart";
  data: {
    chartType: "financial";
    content: {
      chartType: "bar" | "line";
      description: string;
      series: {
        name: string;
        values: {
          x: string;
          y: number;
        }[];
      }[];
      title: string;
      xLabel: string;
      xUnit: string;
      yLabel: string;
      yUnit: string;
    };
    id: string;
    meta: {
      companyName: string;
      definition: string;
      industryName: string;
      name: string;
      reason: string;
      usageScene: string;
    };
  };
}

export interface MacroIrChartReference extends ReferenceDetail {
  citationNumber: number;
  dataType: "macro_ir_chart";
  data: {
    chartType: "macro_ir";
    content: {
      chartType: "bar" | "line";
      description: string;
      series: {
        name: string;
        values: {
          x: string;
          periodTo: string;
          y: number;
        }[];
      }[];
      title: string;
      xLabel: string;
      xUnit: string;
      yLabel: string;
      yUnit: string;
    };
    id: string;
    meta: {
      companyName: string;
      definition: string;
      industryName: string;
      name: string;
      reason: string;
      usageScene: string;
    };
  };
}

export interface MacroChartReference extends ReferenceDetail {
  citationNumber: number;
  dataType: "macro_chart";
  data: {
    chartType: "macro";
    content: {
      chartType: "bar" | "line";
      description: string;
      series: {
        name: string;
        values: {
          x: string;
          periodTo: string;
          y: number;
        }[];
      }[];
      title: string;
      xLabel: string;
      xUnit: string;
      yLabel: string;
      yUnit: string;
    };
    id: string;
    meta: {
      companyName: string;
      definition: string;
      industryName: string;
      name: string;
      reason: string;
      surveyOrganization: string;
      surveyTitle: string;
      usageScene: string;
    };
  };
}

export interface FinancialTableReference extends ReferenceDetail {
  citationNumber: number;
  dataType: "financial_table";
  data: {
    content: {
      description: string;
      header: string[];
      name: string;
      values: (string | number)[][];
    };
    id: string;
    meta: {
      reason: string;
    };
    tableType: string;
  };
}

export interface CompanyListTableReference extends ReferenceDetail {
  citationNumber: number;
  dataType: "company_list_table";
  data: {
    content: {
      description: string;
      header: string[];
      name: string;
      values: (string | number)[][];
    };
    id: string;
    meta: {
      reason: string;
      searchConditionsSummary: {
        conditions: {
          clauseLabel: string;
          clauseType: string;
          conditions: {
            conditionLabel: string;
            conditionType: string;
            field: string;
            fieldLabel: string;
            rawValue: string[];
            valueLabels: string[];
          }[];
          sizeLimit: number;
        }[];
        title: string;
        sizeLimit: number;
        sort: {
          field: string;
          fieldLabel: string;
          order: string;
          orderLabel: string;
        }[];
      };
      title: string;
      total: number;
    };
    tableType: "company_list";
  };
}

export type Reference =
  | ArticleReference
  | FinancialChartReference
  | MacroIrChartReference
  | MacroChartReference
  | FinancialTableReference
  | CompanyListTableReference;

export interface Chat {
  talkId?: string;
  hideChatForm?: boolean;
  title: string;
  history: {
    question: string;
    questionOptimization?: string;
    questionAt?: string;
    answer: string;
    reference?: Reference[];
    progress?: string;
    sseStatus?: SseStatus;
    relatedQuestions?: string[];
    isTextGenerating?: boolean;
    ids?: {
      questionId: string;
      answerId: string;
    };
    isError?: boolean;
    errorCode?: number;
    visibleRetryButton?: boolean;
  }[];
}

// ダウンロードタイプ定義
export type DownloadType = "pdf" | "docx" | "md";

export enum DownloadTypeEnum {
  PDF = "1",
  DOCX = "2",
  MD = "3"
}
